import { useState } from "react";

export interface AccordionProps {
    isAccordionOpen: boolean;
    title: string;
    content: React.ReactElement;
    isStyle2?: boolean;
}

const COMPONENT_CLASS = "c-accordion";

const Accordion: React.FunctionComponent<AccordionProps> = (props) => {
    const {
        isAccordionOpen,
        title,
        content,
        isStyle2,
    } = props

    const [isOpen, setIsOpen] = useState(isAccordionOpen);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`${COMPONENT_CLASS}`}>
            <div className={`${COMPONENT_CLASS}__item${isStyle2 ? "__style-2" : ""} ${isOpen ? "open" : ""}`}>
                <div className="accordion-title" onClick={() => toggle()}>{title}</div>
                <div className="accordion-content">{content}</div>
            </div>
        </div>
    );
};

export default Accordion;